import "./utils/dayjsConfig";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { createBrowserRouter, Link, RouterProvider } from "react-router";

import { ROUTES } from "./constants/routes.constant.ts";
import Login from "./pages/auth/login/login.tsx";
import { Provider } from "react-redux";
import { store } from "./store/store";
import PublicRoute from "./route/public.route.tsx";
import { Button, ConfigProvider, Flex, Result } from "antd";
import theme from "./theme.json";
import { formRequiredMark } from "./utils/formRequiredMark";
import { PUBLIC_ROUTES } from "./constants/public-routes.constants.ts";
import DraftRoute from "./route/draft.route.tsx";
import EventAdminReviewRoute from "./route/eventAdminReview.route.tsx";
import Logo from "./components/Logo.tsx";
import Loader from "./components/Loader.tsx";

const routes = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: Object.entries(ROUTES)?.map(
      ([, { path, component: Component, title, draftCheck }]) => ({
        path,
        element: (
          <>
            <title>{title}</title>

            <DraftRoute checkForDraft={draftCheck}>
              <EventAdminReviewRoute>
                <Suspense fallback={<Loader />}>
                  <Component />
                </Suspense>
              </EventAdminReviewRoute>
            </DraftRoute>
          </>
        ),
      })
    ),
  },
  {
    path: "/login",
    element: (
      <PublicRoute
        element={
          <>
            <title>{"Login"}</title>

            <Login />
          </>
        }
      />
    ),
  },
  ...Object.values(PUBLIC_ROUTES).map((route) => {
    return {
      path: route.path,
      element: (
        <PublicRoute
          element={
            <>
              <title>{route.title}</title>
              <route.component />
            </>
          }
        />
      ),
    };
  }),
  {
    path: "*",
    element: (
      <Flex vertical gap={24} align="center" style={{ marginTop: 48 }}>
        <Logo />
        <Result
          status={404}
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Link to={"/login"}>
              <Button>Take me home</Button>
            </Link>
          }
        />
      </Flex>
    ),
  },
]);

createRoot(document.getElementById("root")!).render(
  <ConfigProvider
    theme={theme}
    form={{
      requiredMark: formRequiredMark,
      validateMessages: {
        required: "This field is required",
      },
    }}
  >
    <Provider store={store}>
      <RouterProvider router={routes} />
    </Provider>
  </ConfigProvider>
);
